import React, { Component } from 'react';
import Hero from "./../../alpineComponents/hero";
import BannerFadeIn from "./../../components/bannerFadeIn";
import Footer from './../../components/footer';
import {GetUrlVariable} from './../../utils/constants';
export default class ThankYou extends Component {

  render() {
    let type = GetUrlVariable('type');
    let title = 'Thanks, homie!';
    let subtitle = 'Your message has been sent.';
    if(type == 'notify'){
      title = "*Doing a happy dance*"
      subtitle ="I can't wait either...You'll be notified as soon as copies become available."
    }
    if(type == 'speaking'){
      title = "Thanks for requesting more information."
      subtitle ="A member of our team will contact you shortly."
    }
    return (
      <div>
        <BannerFadeIn>
          <Hero
            backgroundImage={'/images/cuba-hero.jpg'}
            subtitle={subtitle}
            title={title}
            link="/"
            buttonText="Continue"
            mobileOptimize={true}
          />
        </BannerFadeIn>
        <Footer />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/thankYou/index.js